import type { Me } from "@contract/firm/me";
import { Text } from "@mantine/core";
import { ProgressMeter } from "../../ui/ProgressMeter";
import { SectionCard } from "../../ui/SectionCard";
import { creditsSummary, timeMeter } from "../homeModel";

/** The Usage card (Home, frame 15187:6107; Plan & Billing, frame 15199:6383): the share of
 * this period's AI credits used, and how far through the trial or the billing period we are. */
export function UsageCard({ me, now }: { me: Me; now: Date }) {
  const credits = creditsSummary(me);
  const time = timeMeter(me, now);
  return (
    <SectionCard title="Usage">
      {credits.kind === "unlimited" ? (
        <Text>Unlimited AI credits on your plan.</Text>
      ) : (
        <ProgressMeter share={credits.share} label="SlideBrain AI Credits Used" />
      )}
      {time ? <ProgressMeter share={time.share} label={time.label} /> : null}
    </SectionCard>
  );
}
